export default {
	sec_10: {
		title: {
			one: 'Platform and ',
			two: 'Features',
		},
		desc: {
			one: 'Optimized for business management.',
			two: 'Tailored exclusively for businesses.',
		},
		btn: {
			one: 'Sign up',
			two: 'Download App',
		},
	},
	sec_05: {
		title: {
			one: 'From franchise management to ',
			two: 'accurate settlement',
		},
		desc: {
			one: 'Discover a platform optimized for your business.',
		},
	},
	sec_11: {
		one: {
			title: {
				one: "It's intuitive and simple.",
			},
			desc: {
				one: 'When it comes to business, keep it as simple as possible.',
			},
		},
		two: {
			title: {
				one: 'Can be used immediately',
				two: 'without learning',
			},
			desc: {
				one: "We've kept the platform and features as simple as possible, ",
				two: 'making it easy for administrators to use.',
			},
		},
	},
};
